"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultPanelConfigurations = void 0;
var DefaultPanelConfigurations = exports.DefaultPanelConfigurations = {
  emailPanel: {
    actionButtonsBars: {
      primary: {
        actionItems: [{
          buttonLabel: 'Submit',
          id: 'submitButton',
          buttonStyle: 'primary',
          showSpinner: true
        }, {
          id: 'cancelButton',
          buttonStyle: 'secondary',
          buttonLabel: 'Back',
          showSpinner: true
        }],
        containerType: 'row spaceBetween'
      }
    }
  },
  manualAddressEntryPanel: {
    actionButtonsBars: {
      primary: {
        actionItems: [{
          buttonLabel: 'Save',
          id: 'submitButton',
          buttonStyle: 'primary'
        }, {
          id: 'cancelButton',
          buttonStyle: 'secondary',
          buttonLabel: 'Close'
        }],
        containerType: 'row spaceBetween'
      }
    }
  },
  postcodeWarningPanel: {
    actionButtonsBars: {
      primary: {
        actionItems: [{
          buttonLabel: 'New Quote',
          id: 'submitButton',
          buttonStyle: 'primary'
        }, {
          id: 'cancelButton',
          buttonStyle: 'secondary',
          buttonLabel: 'Back'
        }],
        containerType: 'row spaceBetween'
      }
    }
  }
};